export default __webpack_public_path__ + "static/media/airdropss.9c408caa.svg";